"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainId = exports.Chain = void 0;
var Chain;
(function (Chain) {
    Chain["BITCOIN"] = "bitcoin";
    Chain["BOB"] = "bob";
    Chain["BOB_SEPOLIA"] = "bob-sepolia";
})(Chain || (exports.Chain = Chain = {}));
var ChainId;
(function (ChainId) {
    ChainId[ChainId["BOB"] = 60808] = "BOB";
    ChainId[ChainId["BOB_SEPOLIA"] = 808813] = "BOB_SEPOLIA";
})(ChainId || (exports.ChainId = ChainId = {}));
